import { computed, ref } from 'vue'
import { segmentsService } from '../index'
import { convertTag } from '@b2ag/utils/src/convertTag'

// shared global state
const userSegments = ref<string[]>([])

// Composable pour la gestion des segments utilisateur
export function useUserSegments() {
  async function fetchFreshUserSegments({
    cartData,
    customerCode,
    partnerId,
  }: {
    cartData?: {
      id?: string
      line_items?: Array<{ offer_id: string; quantity: number }>
      user?: { segments?: string[] }
    }
    customerCode: string
    partnerId: string
  }): Promise<string[]> {
    if (!segmentsService) throw new Error('Segments services is not available')

    try {
      const offersInfos =
        cartData?.line_items?.map((item) => ({
          id: item.offer_id,
          quantity: item.quantity,
        })) ?? []

      const response = await segmentsService.fetchDynamicSegments({
        partnerId: partnerId,
        customerCode: customerCode,
        requests: [{ id: cartData?.id ?? 'no-cart-id', offers: offersInfos }],
      })

      if (response && response[0] && response[0].segments?.length > 0) {
        const segments = response[0].segments
        updateUserSegments(segments)
        return segments
      }

      // Si aucun segment n'est retourné mais que le cart a des segments, on les utilise
      if (cartData?.user?.segments && cartData.user.segments.length > 0) {
        updateUserSegments(cartData.user.segments)
        return cartData.user.segments
      }
      return []
    } catch (_error) {
      // En cas d'erreur, on conserve les segments du cart si disponibles
      if (cartData?.user?.segments && cartData.user.segments.length > 0) {
        updateUserSegments(cartData.user.segments)
        return cartData.user.segments
      }
      return []
    }
  }

  function updateUserSegments(segments: string[] = []) {
    userSegments.value = [...segments]
  }

  function areUserSegmentsEmpty() {
    return userSegments.value.length === 0
  }

  const userMarketingSegments = computed(() => [
    ...(userSegments.value?.map((segment: string) => `segment${convertTag(segment)}`) || []),
    'segmentAll',
  ])

  // Retourner l'état readonly et les fonctions
  return {
    areUserSegmentsEmpty,
    fetchFreshUserSegments,
    userMarketingSegments,
    updateUserSegments,
    userSegments,
  }
}
